import { render, staticRenderFns } from "./MarkdownBlock.vue?vue&type=template&id=4f308d97&"
import script from "./MarkdownBlock.vue?vue&type=script&lang=js&"
export * from "./MarkdownBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports